import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { RechnungsVorlagenQuerySorterConfig } from 'fa-kt.types';
import { RechnungsVorlagenService } from '../service';

@Component({
  selector: 'fa-kt-rechnungs-vorlagen-sorter',
  templateUrl: './rechnungs-vorlagen-sorter.component.html',
  styleUrls: ['./rechnungs-vorlagen-sorter.component.css'],
})
export class RechnungsVorlagenSorterComponent {
  public RechnungsVorlagenSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public rechnungsVorlagen: RechnungsVorlagenService,
  ) {
    this.RechnungsVorlagenSorterConfig = RechnungsVorlagenQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
